/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Deep_P1Inputs */

const en_diff_deep_p1 = /** @type {(inputs: Diff_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objects are matched by key, which is the obvious and correct behaviour. Arrays are matched by index, which is the simple behaviour but not always the one you want. Index matching means element zero is compared to element zero regardless of content, so it reports what changed at each position rather than which items were added or removed.`)
};

const ko_diff_deep_p1 = /** @type {(inputs: Diff_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체는 키로 대응되며 이는 당연하고 올바른 동작입니다. 배열은 인덱스로 대응되며 이는 단순한 동작이지만 언제나 원하는 것은 아닙니다. 인덱스 대응은 내용과 무관하게 0번 요소를 0번 요소와 비교한다는 뜻이며, 어떤 항목이 추가되거나 제거되었는지가 아니라 각 위치에서 무엇이 바뀌었는지를 보고합니다.`)
};

const ja_diff_deep_p1 = /** @type {(inputs: Diff_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトはキーで対応され、これは当然かつ正しい挙動です。配列は添字で対応され、これは単純な挙動ですが、常に望むものとは限りません。添字対応とは、内容にかかわらず 0 番要素を 0 番要素と比べるということで、どの項目が追加または削除されたかではなく、各位置で何が変わったかを報告します。`)
};

/**
* | output |
* | --- |
* | "Objects are matched by key, which is the obvious and correct behaviour. Arrays are matched by index, which is the simple behaviour but not always the one you..." |
*
* @param {Diff_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_deep_p1 = /** @type {((inputs?: Diff_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_deep_p1(inputs)
	if (locale === "ko") return ko_diff_deep_p1(inputs)
	return ja_diff_deep_p1(inputs)
});